import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { AbUsuarioCredencial } from 'app/abstract/full-pages/credencial/usuario-credencial.abstract';
import { Observable } from 'rxjs';

@Injectable({ providedIn: 'root' })
export class UsuarioCredencialService extends AbUsuarioCredencial {
    prefixo = 'usuario_credencial/';

    constructor(httpClient: HttpClient) {
        super(httpClient);
    }

    public getAllDto(): Observable<any> {
        return this.get(`${this.prefixo}findAll`);
    }


    public vinculaCredencialPessoa(dto: any): Observable<any> {
        return this.post(`${this.prefixo}vincula_credencial`, dto);
    }


    public desvinculaCredencialPessoa(credencialId: number): Observable<any> {
        return this.get(`${this.prefixo}desvincula_credencial/${credencialId}`);
    }

    public getDtoByPessoaId(pessoaId: number): Observable<any> {
        return this.get(`${this.prefixo}findByPessoaId/${pessoaId}`);
    }

}